import { useMgPrisConfig } from '@retail/app/stores/app-config';
import { QueryOptions, UseFetchOptions, useMutateFetch } from '@shared/fetch-utils';
import { useAuthContext } from './AuthContext';
import { BrandDTO } from '@retail/auth/types';
import { buildUrl } from '@shared/utils';
import { mpeApi } from '@retail/mgpris/config';
import { handleFetchErrorWithTokenRefresh } from '@retail/utils';
import { useAuth0 } from '@auth0/auth0-react';

interface Props extends QueryOptions {
  headers: Record<string, string>;
}

export function useMutateFetchMyBrands({ headers, ...queryOptions }: Props) {
  const { mpe } = useMgPrisConfig();
  const { token } = useAuthContext();
  const { getAccessTokenSilently } = useAuth0();

  const baseOptions: UseFetchOptions = {
    method: 'GET',
    queryKey: ['my-brands', token],
    url: buildUrl({
      base: mpe.url,
      route: mpeApi.brands.getFullLinkPath(),
      searchParams: { onlyMyBrands: true },
    }),
    headers,
    ...queryOptions,
  };

  return useMutateFetch<BrandDTO[]>({
    ...baseOptions,
    token,
    onRejected: handleFetchErrorWithTokenRefresh(getAccessTokenSilently, baseOptions),
  });
}
